<header class="bg-primary p-3">

  <div class="container">

    <nav class="navbar main-nav">

      <div class="logo">
        <img src="assets/imagens/logo_branca.png">
      </div>

      <ul class="float-right">
        <li class="drop-down">
          <a><i class="flag-icon {{ idiomaSelecionado.FLAG }}"></i><span
              class="d-none">{{ idiomaSelecionado.TITULO }}</span><i class="fas fa-angle-down ml-2"></i></a>
          <ul>
            <li *ngFor="let idioma of idiomas">
              <a *ngIf="idiomaSelecionado.CODIGO != idioma.CODIGO" (click)="alterarIdioma(idioma.CODIGO)"><i
                  class="flag-icon {{ idioma.FLAG }} mr-2"></i>{{ idioma.TITULO }}</a>
            </li>
          </ul>
        </li>
      </ul>

    </nav>

  </div>

</header>

<main>

  <div class="container">

    <div class="row mt-5 text-justify">
      <div class="col-md-12">
        <h2 class="text-center">{{ data.TITULO }}</h2>
        <h4><b>{{ data.TERMO_01 }}</b></h4>
        <p>{{ data.DESCRICAO_TERMO_01 }}</p>
      </div>
    </div>

    <div class="row text-justify">
      <div class="col-md-12">
        <h4><b>{{ data.TERMO_02 }}</b></h4>
        <p>{{ data.DESCRICAO_TERMO_02 }}</p>
        <ol>
          <li *ngFor="let t02 of data.LISTA_TERMO_02">
            <p>{{ t02.TEXTO }}</p>
          </li>
        </ol>
      </div>
    </div>

    <div class="row text-justify">
      <div class="col-md-12">
        <h4><b>{{ data.TERMO_03 }}</b></h4>
        <ol>
          <li *ngFor="let t03 of data.LISTA_TERMO_03">
            <p>{{ t03.TEXTO }}</p>
          </li>
        </ol>
      </div>
    </div>

    <div class="row text-justify">
      <div class="col-md-12">
        <h4><b>{{ data.TERMO_04 }}</b></h4>
        <p>{{ data.DESCRICAO_TERMO_04 }}</p>
        <div *ngFor="let t04 of data.LISTA_TERMO_04">
          <p><b>{{ t04.TITULO }}</b></p>
          <p>{{ t04.DESCRICAO }}</p>
        </div>
      </div>
    </div>

    <div class="row text-justify">
      <div class="col-md-12">
        <h4><b>{{ data.TERMO_05 }}</b></h4>
        <p>{{ data.DESCRICAO_TERMO_05 }}</p>
        <div *ngFor="let t05 of data.LISTA_TERMO_05">
          <p><b>{{ t05.TITULO }}</b></p>
          <p>{{ t05.DESCRICAO }}</p>
        </div>
      </div>
    </div>

  </div>

</main>